import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const TOOL_MAP = {
  "/tools/reply-assistant": "reply_assistant",
  "/tools/proposal-generator": "proposal_generator",
  "/tools/client-analyzer": "client_analyzer",
};

export default function ToolRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const tool = TOOL_MAP[location.pathname] || "reply_assistant";
    navigate(`/workspace?tool=${tool}`, { replace: true });
  }, [location.pathname, navigate]);
  return null;
}
